import Alarm from 'components/Common/Alarm/Alarm';
import Analysis from 'features/Analysis/pages/Analysis/Analysis';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import HomePage from './pages/Home/HomePage';
import ManagementUser from './pages/Management/Management';

export default function UserFeature() {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/home`}>
        <HomePage />
      </Route>
      <Route path={`${match.path}/management`}>
        <ManagementUser />
      </Route>
      <Route path={`${match.path}/analysis`}>
        <Analysis />
      </Route>
      <Route path={`${match.path}/alarm`}>
        <Alarm />
      </Route>
    </Switch>
  );
}
